module.exports = __webpack_public_path__ + "static/media/message_sent.2f01606b.svg";